import DataGrid from '../DataGrid';
import { AsyncDataGridContext } from './context';
class AsyncPagination extends DataGrid.Pagination {
  get lastPageNumber() {
    const {
      filteredRows,
      pagination = this.defaultPaginationState
    } = this.context;
    return Math.ceil(filteredRows.length / pagination.pageSize) - 1;
  }
}
AsyncPagination.contextType = AsyncDataGridContext;
export default AsyncPagination;